// extracted by mini-css-extract-plugin
export var buttonContainer = "ProductCardSlider-module--buttonContainer--4d19f";
export var hidden = "ProductCardSlider-module--hidden--3ec5b";
export var label = "ProductCardSlider-module--label--8310d";
export var productCardSlider = "ProductCardSlider-module--productCardSlider--aada9";
export var slider = "ProductCardSlider-module--slider--04cd1";
export var titleContainer = "ProductCardSlider-module--titleContainer--e5776";